import { QUICK_PLAY_GRID } from "../routes";

/** Only 4×4 + Easy is free; all other grid/difficulty pairs require subscription. */
export const FREE_GRID_SIZE = QUICK_PLAY_GRID;
export const FREE_DIFFICULTY = "easy";

export const LOCK_EMOJI = "\u{1F512}";

/**
 * Mirrors Swift `SubscriptionManager.isConfigurationLocked(gridSize:difficulty:)`.
 * @param {number|string} gridSize
 * @param {string} difficulty
 * @param {boolean} isSubscribed
 */
export function isConfigurationLocked(gridSize, difficulty, isSubscribed) {
    if (isSubscribed) return false;
    const gs = Number(gridSize);
    const d = String(difficulty || "").toLowerCase();
    return gs !== FREE_GRID_SIZE || d !== FREE_DIFFICULTY;
}

/** Segment label with optional lock cue (e.g. "6×6 🔒"). */
export function formatLockedSegmentLabel(baseLabel, locked) {
    if (!locked) return baseLabel;
    return `${baseLabel} ${LOCK_EMOJI}`;
}

export function isGridSizeLocked(gridSize, isSubscribed) {
    if (isSubscribed) return false;
    return Number(gridSize) !== FREE_GRID_SIZE;
}

export function isDifficultyLocked(gridSize, difficulty, isSubscribed) {
    if (isSubscribed) return false;
    const gs = Number(gridSize);
    const d = String(difficulty || "").toLowerCase();
    if (gs !== FREE_GRID_SIZE) return true;
    return d !== FREE_DIFFICULTY;
}
